import { render, staticRenderFns } from "./ItemEdit_Variants.vue?vue&type=template&id=ab6082b8&"
import script from "./ItemEdit_Variants.vue?vue&type=script&lang=js&"
export * from "./ItemEdit_Variants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports